import { createSlice } from '@reduxjs/toolkit';

interface ChatbotSlice {
  chatbot: {
    id: string;
    name?: string;
    flow?: string;
    workspaceId?: string;
    integrationType?: string;
    connectedChannelId?: string;
    isActive?: boolean;
  };
}

const initialState: ChatbotSlice = {
  chatbot: {
    id: '',
    name: '',
    flow: '',
    workspaceId: '',
    integrationType: '',
    connectedChannelId: '',
    isActive: false,
  },
};

export const chatbotSlice = createSlice({
  name: 'chatbot',
  initialState,
  reducers: {
    selectchatbot: (state, { payload }) => {
      state.chatbot = { ...payload, header: {} };
    },
    resetChatbot: (state) => {
      state.chatbot = initialState.chatbot;
    },
    setChatbot: (state, action) => {
      state.chatbot = action.payload;
    },
    removeChatbot: (state) => {
      state.chatbot = { id: '' };
    },
  },
});

export const { setChatbot, removeChatbot, resetChatbot, selectchatbot } =
  chatbotSlice.actions;

export default chatbotSlice.reducer;
